// src/api/report_api.js
import { API_BASE } from "./common_api";

/**
 * Smart Get-Or-Generate
 * Weekly  → { period: "weekly",  week:  "2025-W10" }
 * Monthly → { period: "monthly", month: "2025-03"  }
 * Custom  → { period: "custom",  start_date: "2025-01-01", end_date: "2025-01-15" }
 */
export async function getOrGenerateReportAPI(email, params) {
  const res = await fetch(`${API_BASE}/reports/get-or-generate`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, ...params }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.detail || "Report fetch/generation failed");
  return data;
}

/**
 * Render full Word-style document (AI classifies into Achievements/Learnings/Challenges/Upcoming)
 * Uses exact week_start / week_end from the saved report
 */
export async function renderDocumentAPI(email, startIso, endIso, period) {
  const res = await fetch(`${API_BASE}/reports/render-document`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, start: startIso, end: endIso, period }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.detail || "Failed to render document");
  return data;
}

/**
 * Fetch stored reports by ISO range (internal fallback)
 */
export async function fetchStoredReportAPI(email, startIso, endIso) {
  const res = await fetch(
    `${API_BASE}/reports/fetch?` +
    `email=${encodeURIComponent(email)}` +
    `&start_date=${encodeURIComponent(startIso)}` +
    `&end_date=${encodeURIComponent(endIso)}`
  );
  const data = await res.json();
  if (!res.ok) throw new Error(data?.detail || "Failed to fetch report");
  return data;
}